export default class Form {
  constructor(data, socket) {
    Object.assign(this, {
      id: data.id,
      title: data.title,
      content: data.content,
      status: data.status,
      scope: data.scope,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
    })
    this.socket = socket
  }

/*
    this.id = id donné à la premiere sauvegarde
    this.title = titre
    this.content = JSON tiré de la lib surveyjs
    this.status = data.status
    this.scope = data.scope
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt

*/
  async save () {
    const data = {}
    Object.keys(this).forEach(key => {
      if (key !== 'socket') {
        data[key] = this[key]
      }
    })
    return await this.socket.service('form.form/SAVE', data)
  }

  async delete () {
    return await this.socket.service('form.form/DELETE', { id: this.id })
  }


  async get () {
    const res = await this.socket.service('form.form/GET', { id: this.id })
    Object.assign(this, res.form)
    return this
  }

  static async list (socket) {
    return await socket.service('form.form/LIST')
  }
}